import { Component, OnInit, ViewChild } from '@angular/core';
import { PasswordPolicy } from '../../../types/password-policy';
import { LogService } from '../../../services/log.service';
import { LoginService } from '../../../services/login.service';
import { PasswordPolicyService } from '../../../services/password-policy.service';
import { ErrorMessage } from '../../../errors/error-message';
import { Errors } from '../../../errors/errors';
import { BaseForm } from '../../../interfaces/BaseForm';
import { PasswordValidators } from './password-expired.customvalidators';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-password-expired',
  templateUrl: './password-expired.component.html',
  styleUrls: ['./password-expired.component.scss']
})
export class PasswordExpiredComponent extends BaseForm implements OnInit {
  new_password: string;
  confirm_password: string;
  submittedPassword: string;
  @ViewChild('newPasswordInput')
  newPasswordInput;
  cognitoPasswordPolicy: PasswordPolicy;
  public passwordResetForm : FormGroup;

  constructor(
    private log: LogService,
    private login: LoginService,
    private passwordPolicy: PasswordPolicyService,
    public fb: FormBuilder
  ) {
    super(log);
    this.passwordResetForm  = this.passwordExpirationForm();
  }

  ngOnInit() {
    this.clear();

    const showPolicyFailure = new ErrorMessage(awsMessage => {
      const failureMessage = this.cognitoPasswordPolicy.validateAgainstCognitoPolicy(
        this.submittedPassword
      );
      if (failureMessage) {
        return `${this.cognitoPasswordPolicy.displayCognitoPolicy()} ${failureMessage}`;
      } else {
        return awsMessage;
      }
    });

    this.errorHandler.add(Errors.INVALID_PARAMETER, showPolicyFailure);
    this.errorHandler.add(Errors.INVALID_PARAMETER_TYPE, showPolicyFailure);
    this.errorHandler.add(Errors.INVALID_PASSWORD, showPolicyFailure);
    this.errorHandler.add(Errors.LIMIT_EXCEEDED);
    this.errorHandler.add(
      Errors.NOT_AUTHORIZED,
      new ErrorMessage('Session has expired. Please log in again.')
    );
    this.errorHandler.add(
      Errors.PASSWORD_EXCEPTION,
      new ErrorMessage(message => message)
    );
    this.errorHandler.add(
      Errors.GENERIC,
      new ErrorMessage(awsMessage => awsMessage)
    );

    this.passwordPolicy
      .getPasswordPolicy(null, this.login.getUsername())
      .subscribe(policy => (this.cognitoPasswordPolicy = policy));
  }

  passwordExpirationForm(): FormGroup {
    return this.fb.group(
      {
        password: [
          null,
          Validators.compose([
            Validators.required,
            // check whether the entered password has a number
            PasswordValidators.patternValidator(/\d/, {
              hasNumber: true,
            }),
            // check whether the entered password has upper case letter
            PasswordValidators.patternValidator(/[A-Z]/, {
              hasCapitalCase: true
            }),
            // check whether the entered password has a lower case letter
            PasswordValidators.patternValidator(/[a-z]/, {
              hasSmallCase: true
            }),
            // check whether the entered password has a special character
            PasswordValidators.patternValidator(
              /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
              {
                hasSpecialCharacters: true
              }
            ),
            Validators.minLength(8)
          ])
        ],
        confirmPassword: [null, Validators.compose([Validators.required])]
      },
      {
        // check whether our password and confirm password match
        validator: PasswordValidators.passwordMatchValidator
      }
    );
  }

  isValid(): boolean {
    if (
      this.isSubmitInProgress ||
      !this.new_password ||
      !this.confirm_password
    ) {
      return false;
    }
    return true;
  }

  clear() {
    this.new_password = '';
    this.confirm_password = '';
    this.newPasswordInput.nativeElement.focus();
  }

  submit() {
    this.isSubmitInProgress = true;

    this.errorMsg = this.passwordPolicy.validate(
      this.new_password,
      this.confirm_password
    );

    if (this.errorMsg) {
      //this.clear();
      this.isSubmitInProgress = false;
      return;
    }

    this.submittedPassword = this.new_password;

    this.log.trace('responding to auth challenge', this.login.getChallenge());
    this.login.respondToExpiredPasswordChallenge(
      this.new_password,
      this.onErrorCallback
    );
  }
}